"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.allProps = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getCountry = getCountry;
exports.setCaretPosition = setCaretPosition;

var _allCountries = require("./all-countries");

var _allCountries2 = _interopRequireDefault(_allCountries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getCountry() {
  return fetch("https://ip2c.org/s").then(function (response) {
    return response.text();
  }).then(function (response) {
    var result = (response || "").toString();

    if (!result || result[0] !== "1") {
      throw new Error("unable to fetch the country");
    }

    return result.substr(2, 2);
  });
}

// Credits: http://blog.vishalon.net/index.php/javascript-getting-and-setting-caret-position-in-textarea/
function setCaretPosition(ctrl, pos) {
  // Modern browsers
  if (ctrl.setSelectionRange) {
    ctrl.focus();
    ctrl.setSelectionRange(pos, pos);

    // IE8 and below
  } else if (ctrl.createTextRange) {
    var range = ctrl.createTextRange();
    range.collapse(true);
    range.moveEnd("character", pos);
    range.moveStart("character", pos);
    range.select();
  }
}

var allProps = exports.allProps = [{
  name: "allCountries",
  type: Array,
  default: _allCountries2.default,
  description: "All countries that are used in <code>libphonenumber-js</code>, can be overridden by this prop",
  inDemo: false
}, {
  name: "autoFormat",
  type: Boolean,
  default: true,
  description: "Auto update the input to the formatted phone number when it's valid",
  inDemo: true
}, {
  name: "customValidate",
  type: [Boolean, RegExp],
  default: false,
  description: "Custom validation RegExp for input",
  inDemo: false
}, {
  name: "defaultCountry",
  default: "",
  type: [String, Number],
  description: "Default country (by iso2 or dialCode), will override the country fetched from IP address of user",
  inDemo: false
}, {
  name: "disabled",
  default: false,
  type: Boolean,
  description: "Disable <code>vue-tel-input</code>, including the input & flag dropdown",
  inDemo: false
}, {
  name: "autoDefaultCountry",
  default: true,
  type: Boolean,
  description: "To fetch default country based on IP address of user",
  inDemo: false
}, {
  name: "dropdownOptions",
  type: Object,
  description: "Options for dropdown, see below",
  inDemo: false
}, {
  name: "dropdownOptions.disabled",
  default: false,
  type: Boolean,
  description: "Disable dropdown",
  inDemo: false
}, {
  name: "dropdownOptions.showDialCodeInList",
  default: true,
  type: Boolean,
  description: "Show dial code in the dropdown list",
  inDemo: true
}, {
  name: "dropdownOptions.showDialCodeInSelection",
  default: false,
  type: Boolean,
  description: "Show dial code in the dropdown selection",
  inDemo: true
}, {
  name: "dropdownOptions.showFlags",
  default: true,
  type: Boolean,
  description: "Show flags in the dropdown selection and list",
  inDemo: true
}, {
  name: "dropdownOptions.showSearchBox",
  default: false,
  type: Boolean,
  description: "Show country search box",
  inDemo: true
}, {
  name: "dropdownOptions.tabindex",
  default: 0,
  type: Number,
  description: "Native dropdown <code>tabindex</code> attribute",
  inDemo: false
}, {
  name: "dropdownOptions.width",
  default: "390px",
  type: String,
  description: "Specify dropdown width"
}, {
  name: "ignoredCountries",
  default: [],
  type: Array,
  description: "List of countries will NOT be shown on the dropdown",
  inDemo: false
}, {
  name: "inputOptions",
  type: Object,
  description: "Options for input, see below",
  inDemo: false
}, {
  name: "inputOptions.autocomplete",
  type: String,
  default: "on",
  description: "Native input <code>autocomplete</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.autofocus",
  type: Boolean,
  default: false,
  description: "Native input <code>autofocus</code> attribute",
  inDemo: false
},
// {
//   name: 'inputOptions.dynamicPlaceholder',
//   default: false,
//   type: Boolean,
//   description: 'Placeholder as a sample phone number in the current country',
//   inDemo: false,
// },
{
  name: "inputOptions.aria-describedby",
  default: "",
  type: String,
  description: "Native input <code>aria-describedby</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.id",
  default: "",
  type: String,
  description: "Native input <code>id</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.maxlength",
  default: 25,
  type: Number,
  description: "Native input <code>maxlength</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.name",
  default: "telephone",
  type: String,
  description: "Native input <code>name</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.showDialCode",
  default: false,
  type: Boolean,
  description: "Show dial code in input",
  inDemo: false
}, {
  name: "inputOptions.placeholder",
  default: "Enter a phone number",
  type: String,
  description: "Placeholder for the input",
  inDemo: false
}, {
  name: "inputOptions.readonly",
  default: false,
  type: Boolean,
  description: "Native input <code>readonly</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.required",
  default: false,
  type: Boolean,
  description: "Native input <code>required</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.tabindex",
  default: 0,
  type: Number,
  description: "Native input <code>tabindex</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.type",
  default: "tel",
  type: String,
  description: "Native input <code>type</code> attribute",
  inDemo: false
}, {
  name: "inputOptions.styleClasses",
  default: "",
  type: [String, Array, Object],
  description: "Custom classes for the <code>input</code>",
  inDemo: false
}, {
  name: "invalidMsg",
  default: "",
  type: String,
  description: "",
  inDemo: false
}, {
  name: "mode",
  default: "auto",
  type: String,
  description: "Allowed values: <code>'auto'</code> (Default set by phone),  <code>'international'</code> (Format number with the dial code i.e. + 61), <code>'national'</code> (Format number without dial code i.e. 0321232)",
  inDemo: true,
  options: ["auto", "national", "international"]
}, {
  name: "onlyCountries",
  default: [],
  type: Array,
  description: "List of countries will be shown on the dropdown",
  inDemo: false
}, {
  name: "preferredCountries",
  default: [],
  type: Array,
  description: "Preferred countries list, will be on top of the dropdown",
  inDemo: false
}, {
  name: "styleClasses",
  default: "",
  type: [String, Array, Object],
  description: "Custom classes for the wrapper",
  inDemo: false
}, {
  name: "validCharactersOnly",
  default: false,
  type: Boolean,
  description: "Only allow valid characters in a phone number (will also verify in <code>mounted</code>, so phone number with invalid characters will be shown as an empty string)",
  inDemo: false
}];

var dfOptionsAllProps = allProps.slice();

var defaultOptions = exports.defaultOptions = dfOptionsAllProps.reduce(function (prv, crr) {
  if (crr.name.includes(".")) {
    var _crr$name$split = crr.name.split("."),
        _crr$name$split2 = _slicedToArray(_crr$name$split, 2),
        key = _crr$name$split2[0],
        nestedKey = _crr$name$split2[1];

    if (prv[key]) {
      Object.assign(prv[key], _defineProperty({}, nestedKey, crr.default));
    } else {
      Object.assign(prv, _defineProperty({}, key, _defineProperty({}, nestedKey, crr.default)));
    }
  } else {
    Object.assign(prv, _defineProperty({}, crr.name, crr.default));
  }
  return prv;
}, {});

exports.default = {
  options: Object.assign({}, defaultOptions)
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/elements/TelInput/utils.js
// module id = hcLJ
// module chunks = 0 1